export enum ReadWriteTypes {
  read = 'read',
  write = 'write',
}
